// Login
export const TERMS_OPENED = 'T&C Opened';
export const DATA_POLICY_OPENED = 'Data Policy Opened';
export const TERMS_ACCEPTED = 'T&C Accepted';
export const LOGOUT = 'Logout';
export const VIEW_SELECTION = 'View Selection';
